import axios from "axios";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const d = err.response?.data?.detail;
    if (err.response?.status === 402 && d?.code === "subscription_required") {
      if (!window.location.pathname.startsWith("/billing")) window.location.href = "/billing";
    }
    return Promise.reject(err);
  }
);

export function fmtErr(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.message) return detail.message;
  if (detail?.msg) return detail.msg;
  return String(detail);
}
